import React, { Fragment } from "react";
import { applyMiddleware, compose, createStore } from "redux";
import persistState from "redux-localstorage";
import Router from "react-router/lib/Router";
import browserHistory from "react-router/lib/browserHistory";
import { syncHistoryWithStore } from "react-router-redux";
import { Provider } from "react-redux";
import { render } from "react-dom";
import { I18nextProvider } from "react-i18next";
import { enableBatching } from "redux-batched-actions";
// @ts-ignore
import { preloadBundleImages } from "../instant-images-preloader/dist/bundle";
import { t } from "helpers/localization";
import defaultRoutes from "./routes";
import i18n from "./i18n";
import rootReducer from "fe2/Reducers/ReducerRoute";

import oldBrowserApplication from "./oldBrowserApplication";
import { startFetching } from "fe2/Actions/ActionProcessing";
import * as containers from "fe2/Containers/";
import * as utils from "helpers/apputils";
import { needShowIntroduction } from "helpers/supply";
import { logPageView } from "helpers/analytics";
import middlewares from "./middlewares";
import settings from "settings";

import { NotificationManager } from "Components/UIKit/UIKit";
import { TooltipProvider } from "@wg/wows-react-uikit";
import DialogProvider from "./Providers/DialogProvider";
import {initCommonmenu} from "./commonmenu";

import "stylesheets/style.scss";

if (window) {
  if (!window.localSettings) {
    window.localSettings = {
      highlighterPercentRegexp: [/[+-](\s{0,1}|&nbsp;)*[0-9,.]{1,3}(\s{0,1}|&nbsp;)*%/]
    };
  }
}

const application = utils.isBrowserSupportsFeatures() ? (store: any) => {
  const {
    AccountInfoSyncManager,
    Layout,
    Dialog,
    GlobalProcessing
  } = containers;
  const state = store.getState();
  const root = state.urls.root;

  const childRoutes = defaultRoutes.map(route => {
    route.onEnter = (nextState, replace) => {
      const state = store.getState();
      if (route.bodyClass) {
        document.body.className = route.bodyClass(state);
      }
      const currentAccount = state.currentAccount;
      if (route.beforeEnter) {
        route.beforeEnter(replace, root, currentAccount, state);
      }
    };

    route.component = containers[route.componentName];

    return route;
  });
  let routes = [{
    path: root,
    component: Layout,
    indexRoute: {
      onEnter: (nextState, replace) => {
        const {
          currentAccount
        } = store.getState();
        let replaceTo = 'profile';
        if (!currentAccount.clanId) {
          replaceTo = currentAccount.activeInvitesCount ? 'requests' : 'search';
        }

        replace({ pathname: `${root}${replaceTo}` });
      }
    },
    childRoutes: childRoutes
  }, {
    path: '*',
    component: null,
    indexRoute: {
      onEnter: (nextState, replace) => {
        replace({ pathname: root });
      }
    }
  }];

  const isEnabledPreloadImages = settings.isEnabledPreloadImages;
  if (isEnabledPreloadImages) {
    window.preloaderBundleImages = {
      all: []
    };

    if (needShowIntroduction(state)) {
      window.preloaderBundleImages.all = [...window.preloaderBundleImages.all];
    }

    const staticURL = state.urls.static;
    window.preloaderBundleImages.all = window.preloaderBundleImages.all.map(imgSrc => {
      return `${staticURL}${imgSrc}`;
    });

    store.dispatch(startFetching());
    store.dispatch(preloadBundleImages());
  }

  const history = syncHistoryWithStore(browserHistory, store);

  // @ts-ignore
  window.store = store

  return <Provider store={store}>
    <I18nextProvider i18n={i18n}>
      <TooltipProvider>
        <DialogProvider>
          <Fragment>
            <Router history={history} routes={routes} onUpdate={logPageView} />
            <Dialog t={t} />
            <GlobalProcessing />
            <AccountInfoSyncManager />
            <NotificationManager />
          </Fragment>
        </DialogProvider>
      </TooltipProvider>
    </I18nextProvider>
  </Provider>;
} : oldBrowserApplication;

utils.checkReduxStorage();

const enhancer = compose(applyMiddleware(...middlewares), persistState(['introduction', 'searchHistory']));
export const store = createStore(enableBatching(rootReducer), window.__PRELOADED_STATE__, enhancer);

render(application(store), document.getElementById('app'));

utils.initEventListeners();

try {
  initCommonmenu();
} catch (e) {
  console.error("Failed to init common menu", e);
}